export * from "@/components/article/dictsys/inflectionSchemes/labels";

type Case = "nominative" | "genitive" | "dative" | "akkusative" | "indicative";
type CaseLabelSet = Record<Case, string>;

export const casusLabels: CaseLabelSet = {
  nominative: "Nominativ",
  genitive: "Genitiv",
  dative: "Dativ",
  akkusative: "Akkusativ",
  indicative: "Indikativ"
};
